import { Component, inject, signal } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AccountDataService } from '../../account-data.service';
import { MaterialModule } from '../../../../modules/material.module';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-change-password-dialog',
  standalone: true,
  imports: [MaterialModule, FormsModule],
  templateUrl: './change-password-dialog.component.html',
  styleUrl: './change-password-dialog.component.scss',
})
export class ChangePasswordDialogComponent {
  private readonly ac = inject(AccountDataService);
  private readonly fb = inject(FormBuilder);

  changePassword: FormGroup;
  passwordChanged = signal({
    message: '',
    isSuccess: false,
  });
  isDisable = false;

  constructor() {
    this.changePassword = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
    });
  }

  /**
   * updates this user's ProjectZen account password in firebase authentication after verifying old password
   */
  changeAccountPassword(): void {
    const self = this;
    self.ac
      .changeAccountPasswordInFirebase(
        self.changePassword.value.oldPassword,
        self.changePassword.value.newPassword
      )
      .then(function () {
        if (environment.debuggingConsoleLogsOn) {
          console.log('Password updated.');
        }

        //show confirmation text saying that password was successfully updated
        self.isDisable = true;
        self.passwordChanged.set({message:'Password successfully updated.', isSuccess: true});
      })
      .catch(function (error) {
        self.passwordChanged.set({message:'Password is incorrect, or something went wrong.', isSuccess: false});
        console.log(error);
      });
  }
}
